// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv[data-v-12d4a639] {\n  margin-right: 10px;\n}\n.excel-upload-input[data-v-12d4a639] {\n  display: none;\n  z-index: -9999;\n}\n\n/*.drop {*/\n/*  border: 2px dashed #bbb;*/\n/*  width: 600px;*/\n/*  height: 160px;*/\n/*  line-height: 160px;*/\n/*  margin: 0 auto;*/\n/*  font-size: 24px;*/\n/*  border-radius: 5px;*/\n/*  text-align: center;*/\n/*  color: #bbb;*/\n/*  position: relative;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
